import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { environment } from './utility/environment';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter basename={`${environment.contextPath}/${environment.contextVersion}/${environment.front}`}>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
